import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  AddEventInDataBase,
  AddStaff,
} from "../../CrudOperations/PostOperation";
import { getAllEvent, getAllEvents, getCommunities } from "../../CrudOperations/GetOperation";
import { updateEventDetailsInDataBase } from "../../CrudOperations/Update&Edit";

const AddEvent = ({ closeModal, onSubmit, EventDetails, onUpdate }) => {



  const [EventName, setEventName] = useState( EventDetails?.EventName || "");           
  const [StartDate, setStartDate] = useState( EventDetails?.StartDate || "");
  const [EndDate, setEndDate] = useState(  EventDetails?.EndDate || "");
  const [StartLocation, setStartLocation] = useState( EventDetails?.StartLocation || "");
  const [EndLocation, setEndLocation] = useState( EventDetails?.EndLocation || "");
  const [EventType, setEventType] = useState( EventDetails?.EventTypeId || "");
  const [Priority, setPriority] = useState( EventDetails?.Priority || "");
  const [Description, setDescription] = useState(  EventDetails?.Description || "");
  const [CommunityId, setCommunityId ] = useState(EventDetails ? EventDetails.CommunityId : "");

  const [Status, setStatus] = useState(   EventDetails?.Status || "");

  const [eventList, setEventList] = useState([]);
  const [communityList, setCommunityList] = useState([]);


  useEffect(() => {
    // priority high 1
    // priority medium 2
    // priority low 0

    const fetchEventList = async () => {
      const response = await getAllEvents();
      console.log(response);

      if (response?.data.length > 0) {
        setEventList(response.data);
      }



        const responsegetCommunities = await getCommunities()
          console.log(responsegetCommunities);
          
      
          if (responsegetCommunities.data.length > 0) {
            setCommunityList(responsegetCommunities.data);
          }
      



    };

    fetchEventList();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    console.log(EventDetails);
    

  if(!EventDetails){



    const response = await AddEventInDataBase(
      EventType,
      EventName,
      StartDate,
      EndDate,
      StartLocation,
      EndLocation,
      Status,
      Priority,
      Description,
      CommunityId
    );

    console.log(response);

    if (response.data.ServerMessage === "Event added successfully.") {
      onSubmit(); // Handle new data
    }


















  }
  else{
console.log(  EventDetails);


    
    const response = await updateEventDetailsInDataBase(
      EventType,
      EventName,
      StartDate,
      EndDate,
      StartLocation,
      EndLocation,
      Status,
      Priority,
      Description,
      EventDetails.EventDetailId,
      CommunityId
    );

    console.log(response);

    if (response.data.ServerMessage === "Event updated successfully.") {
      onSubmit(); // Handle new data
    }








  }



  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">

      <div className="flex justify-between items-center border-b px-6 pt-6 pb-3">
      <h2 className="text-2xl font-semibold text-blue-700 flex items-center gap-2">
            <svg
              className="w-6 h-6 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 4v16m8-8H4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {EventDetails ? "Edit Event" : "Add Event"}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-400 hover:text-red-600 text-xl font-bold"
          >
            &times;
          </button>
        </div>

        <div className="overflow-y-auto px-6 pb-4 pt-2 scrollbar-hide">
        <form onSubmit={handleFormSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700">Event Type *</label>
            <select
              value={EventType}
              onChange={(e) => setEventType(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Event Type</option>
              {eventList.map((p) => (
                <option key={p.EventTypeId} value={p.EventTypeId}>
                  {p.EventTypeName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Event Name *</label>
            <input
              type="text"
              value={EventName}
              onChange={(e) => setEventName(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Description *</label>
            <input
              type="text"
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Start Date & Time *</label>
            <input
              type="datetime-local"
              value={StartDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">End Date & Time *</label>
            <input
              type="datetime-local"
              value={EndDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Start Location *</label>
            <input
              type="text"
              value={StartLocation}
              onChange={(e) => setStartLocation(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">End Location</label>
            <input
              type="text"
              value={EndLocation}
              onChange={(e) => setEndLocation(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Priority *</label>
            <select
              value={Priority}
              onChange={(e) => setPriority(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Priority</option>
              <option key={1} value={1}>
                High
              </option>

              <option key={0} value={0}>
                Low
              </option>
            </select>
          </div>
          
          <div className="mb-2">
            <label className="block text-gray-700">Community *</label>
            <select
              value={CommunityId}
              onChange={(e) => setCommunityId(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Community</option>
              {communityList?.length > 0 &&
                  communityList.map((commu) => (
                    <option key={commu.CommunityId} value={commu.CommunityId}>
                 {commu.CommunityName}  
                    </option>
                  ))}
            </select>
          </div>


          <div className="mb-2">
            <label className="block text-gray-700">Status *</label>
            <select
              value={Status}
              onChange={(e) => setStatus(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Status</option>
              <option key={1} value={1}>
                Active
              </option>

              <option key={0} value={0}>
                InActive
              </option>
            </select>
          </div>

        </form>
        </div>


           {/* Sticky Footer Buttons */}
           <div className="flex justify-end gap-3 border-t px-6 py-4 bg-white sticky bottom-0">
          <button
            type="button"
            onClick={closeModal}
            className="px-4 py-2 rounded-md border border-gray-400 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
          onClick={handleFormSubmit}
            type="submit"
            form="yourFormId" // optional if you separate form
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            {EventDetails ? "Update" : "Submit"}
          </button>
        </div>



      </div>
    </div>
  );
};

export default AddEvent;
